// extracted by mini-css-extract-plugin
export default {"patientTableContainer":"TablePatients_patientTableContainer__dBMh5"};